
import NewsSlider from "@/components/NewsSlider.vue";
import FIcon from '@fixit/icons/src/components/FIcon.vue'
import Breadcrumbs from '../../components/Breadcrumbs.vue';
export default {
  head() {
    let metaTagsTemplate = `%s | ${this.$store.getters["cmsConfigHomepage/getChainName"]}`
    return {
      title: this.news.metaTags.title,
      titleTemplate: metaTagsTemplate,
      meta: [
        {
          hid: 'title',
          name: 'title',
          template: metaTagsTemplate,
          content: this.news.metaTags.title,
        }, {
          hid: 'description',
          name: 'description',
          content: this.news.metaTags.description
        }, {
          hid: 'keywords',
          name: 'keywords',
          content: this.news.metaTags.keywords
        }, {
          hid: 'og:type',
          name: 'og:type',
          content: this.news.metaTags.ogType
        }, {
          hid: 'og:url',
          name: 'og:url',
          content: this.news.metaTags.ogUrl
        }, {
          hid: 'og:title',
          name: 'og:title',
          template: metaTagsTemplate,
          content: this.news.metaTags.ogTitle,
        }, {
          hid: 'og:description',
          name: 'og:description',
          content: this.news.metaTags.ogDescription
        }
      ]
    }
  },
  layout: "HomepageLayout",
  name: "newsSingle",
  components: { NewsSlider, FIcon, Breadcrumbs },
  async asyncData(context) {
    let news = await context.store.dispatch("news/getNewsById", parseInt(context.route.params.id))
    return {news}
  },
  data: () => ({
    isMounted: false,
  }),
  computed: {
    breadcrumbs() {
      return [
        {name: 'Hjem', disabled: false, href: '/'},
        {name: 'Artikler', disabled: false, href: '/news'},
        {name: this.news.title, disabled: true, href: this.$route.params.id, isEndpoint: true}
      ]
    },
    otherNews() {
      var news = this.$store.getters["news/getNews"];
      var id = parseInt(this.$route.params.id);
      return news.filter(function (x) {
        return x.id != id;
      });
    },
    allNews() {
      return this.$store.getters["news/getNews"];
    },
    isDraft() {
      return this.$store.getters['cmsConfigHomepage/isDraftMode']
    }
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getImage(item) {
      if (item == null || item.imgUrl == null || item.imgUrl === undefined) {
        return null;
      }
      if (typeof String.prototype.replaceAll == "undefined") {
        String.prototype.replaceAll = function (match, replace) {
          return this.replace(new RegExp(match, "g"), () => replace);
        };
      }
      return item.imgUrl.replaceAll('"', "");
    },
    formatBody(item) {
      if (typeof String.prototype.replaceAll == "undefined") {
        String.prototype.replaceAll = function (match, replace) {
          return this.replace(new RegExp(match, "g"), () => replace);
        };
      }
      return item.body.replaceAll("\n", "</br>");
    },
    redirect(url) {
      window.open(url, '_self')
    }
  },
  watch: {
    $route() {
      this.scrollToTop();
    },
  },
};
